import {
  Container,
  Typography,
  Grid,
  Box,
  Button,
  ListItemButton,
  Avatar,
  Paper,
} from "@mui/material";
import EuroIcon from "@mui/icons-material/Euro";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useStyles } from "./datagridcard-styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
 
import {
  LineChart,
  Line,
 
} from "recharts";
import { useTheme } from "@mui/material/styles";
const tinyChartData = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const TinyLineChart = () => {
  const classes = useStyles();

  const theme = useTheme();
  return (
    // <ResponsiveContainer  >
    <LineChart    className={classes.tinygraph} width={120} height={70} data={tinyChartData}>
      <Line
        type="monotone"
        dataKey="pv"
        stroke={theme.palette.primary.main}
        strokeWidth={2}
        dot={false}
      />
    </LineChart>
 // </ResponsiveContainer>  
  );
};

export const DataGridCard = () => {
  const classes = useStyles();

  const listItem = (
    <ListItem className={classes.dataTableItem}>
      <Avatar
        className={classes.dataGridAvatar}
        src="http://admin.pixelstrap.com/viho/assets/images/dashboard/product-1.png"
      >
        <EuroIcon />
      </Avatar>

      <ListItemText primary="Yellow New Nike shoes" />

      <Button variant="text"> Edit</Button>

      <Button variant="text"> Delete</Button>
      <TinyLineChart />
      <Typography> $210326 </Typography>

      <Box px={7}>
        {" "}
        <Typography> Done </Typography>
      </Box>
    </ListItem>
  );

  return (
    <>
      <Paper className={classes.paper} variant="elevation" elevation={0}>
        <Box className={classes.cardContentsWrapper}>
          <Box className={classes.cardTextArea}>
            <Typography variant="h6" className={classes.cardHeader}>
              Recent Orders
            </Typography>
          </Box>

          <Box sx={{ display: "flex" }}>
            <List className={classes.dataTableList}>
              {listItem}

              {listItem}

              {listItem}

              {listItem}
              {listItem}

              {listItem}
            </List>
          </Box>
        </Box>
      </Paper>
    </>
  );
};
